import { render, staticRenderFns } from "./List.vue?vue&type=template&id=3397bc36"
import script from "./List.vue?vue&type=script&lang=js"
export * from "./List.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/websites/streamlined-business-solutions/sbs-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3397bc36')) {
      api.createRecord('3397bc36', component.options)
    } else {
      api.reload('3397bc36', component.options)
    }
    module.hot.accept("./List.vue?vue&type=template&id=3397bc36", function () {
      api.rerender('3397bc36', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/industry/List.vue"
export default component.exports